import React from "react";
import PropTypes from "prop-types";
import { widthViewTypes, noPaddingAllTypes } from "../../constants";
import classNames from "classnames";

/**
 * Получить парметры для col
 * @param {String} size = xs, sm, md, lg, xl
 * @param {Number|Object} prop - Цифра или объект с нстройками
 */
function getSizeProps(size, prop) {
  let resultProps = {};

  if (prop) {
    // col-xs
    if (typeof prop === "boolean") {
      resultProps = {
        [`col-${size}`]: true
      };
      // col-xs-12
    } else if (typeof prop === "number") {
      resultProps = {
        [`col-${size}-${prop}`]: true
      };
    } else if (typeof prop === "object") {
      // hide-xs
      if (prop.hasOwnProperty("hide")) {
        resultProps = {
          ...resultProps,
          [`hide-${size}`]: prop.hide
        };
        // hide-xs-only
      } else if (prop.hasOwnProperty("hideOnly")) {
        resultProps = {
          ...resultProps,
          [`hide-${size}-only`]: prop.hideOnly
        };
        // show-xs
      } else if (prop.hasOwnProperty("show")) {
        resultProps = {
          ...resultProps,
          [`show-${size}`]: prop.show
        };
        // show-xs-only
      } else if (prop.hasOwnProperty("showOnly")) {
        resultProps = {
          ...resultProps,
          [`show-${size}-only`]: prop.showOnly
        };
        // col-xs-only-12
      } else if (
        prop.hasOwnProperty("only") &&
        typeof prop.only === "number" &&
        prop.only > 0 &&
        prop.only <= 12
      ) {
        resultProps = {
          ...resultProps,
          [`col-${size}-only-${prop.only}`]: true
        };
        // col-xs-12
      } else if (
        prop.hasOwnProperty("span") &&
        typeof prop.span === "number" &&
        prop.span > 0 &&
        prop.span <= 12
      ) {
        resultProps = {
          ...resultProps,
          [`col-${size}-${prop.span}`]: true
        };
      }

      // col-xs-offset-12
      if (
        prop.hasOwnProperty("offset") &&
        typeof prop.offset === "number" &&
        prop.offset > 0 &&
        prop.offset <= 12
      ) {
        resultProps = {
          ...resultProps,
          [`col-${size}-offset-${prop.offset}`]: true
        };
      }

      // first-xs
      if (prop.hasOwnProperty("first")) {
        resultProps = {
          ...resultProps,
          [`first-${size}`]: prop.first
        };
        // last-xs
      } else if (prop.hasOwnProperty("last")) {
        resultProps = {
          ...resultProps,
          [`last-${size}`]: prop.last
        };
      }
    }
  }

  return resultProps;
}

class Col extends React.Component {
  render() {
    let colClassNames = classNames(
      "col",
      {
        ...getSizeProps("xs", this.props.xs),
        ...getSizeProps("sm", this.props.sm),
        ...getSizeProps("md", this.props.md),
        ...getSizeProps("lg", this.props.lg),
        ...getSizeProps("xl", this.props.xl),

        first: this.props.first,
        last: this.props.last,
        main: this.props.main,
        normal: this.props.normal,

        [`padding-${this.props.padding}`]: this.props.padding,
        [`text-${this.props.text}`]: this.props.text,
        [`col-${this.props.white}`]: this.props.white,
        [`background-${this.props.background}`]: this.props.background
      },
      this.props.className
    );

    let { style, width, children } = this.props;
    style = typeof style === "object" ? style : {};

    if (width && (typeof width === "string" || typeof width === "number")) {
      style.width = width;
    }

    return (
      <div className={colClassNames} style={style}>
        {children}
      </div>
    );
  }
}

Col.defaultProps = {
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  padding: false,
  text: false,
  first: false,
  last: false,
  white: false,
  main: false,
  normal: false,
  className: "",
  style: {},
  width: null,
  background: null,
  children: null
};

// Настройки col
const colProps = PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.number, // 1-12
  PropTypes.shape({
    hide: PropTypes.bool,
    hideOnly: PropTypes.bool,

    show: PropTypes.bool,
    showOnly: PropTypes.bool,

    span: PropTypes.oneOf(widthViewTypes),
    only: PropTypes.oneOf(widthViewTypes),
    offset: PropTypes.oneOf(widthViewTypes),

    first: PropTypes.bool,
    last: PropTypes.bool
  })
]);

Col.propTypes = {
  /* Основной отступ */
  span: colProps,
  /* Define a column with auto-sizing on XS and up */
  xs: colProps,
  /* Define a column with auto-sizing on SM and up */
  sm: colProps,
  /* Define a column with auto-sizing on MD and up */
  md: colProps,
  /* Define a column with auto-sizing on LG and up */
  lg: colProps,
  /* Define a column with auto-sizing on XL and up */
  xl: colProps,
  /* Отступы */
  padding: PropTypes.oneOf(noPaddingAllTypes),
  /* Направление текста */
  text: PropTypes.oneOf([false, "left", "center", "right"]),
  /* Сделать колонку первой в строке */
  first: PropTypes.bool,
  /* Сделать колонку последней в строке на XS и выше */
  last: PropTypes.bool,
  /* Белый фон */
  white: PropTypes.bool,
  /* Сделать колонку основной, занять всё пространство, за исклчением той, у которой normal */
  main: PropTypes.bool,
  /* Сделать колонку второстипенной, только то пространство, которое занято внутренними элементами */
  normal: PropTypes.bool,
  /* Определить класс */
  className: PropTypes.string,
  /* Определить стиль */
  style: PropTypes.objectOf(
    PropTypes.oneOfType(PropTypes.string, PropTypes.number)
  ),
  /* Определить ширину */
  width: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
  /* Определить фон */
  background: PropTypes.oneOf([false, "main", "white"]),
  children: PropTypes.node
};

export default Col;
